export const CUSTOM_HEADERS = {
  localDateTime: 'X-Local-Date-Time',
};
